import en from './localeEn';
import es from './localeEs';
import pt from './localePt';

const locales = { es, pt, en } as const;

export default locales;
